import styles from "./Prefit.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import Link from "next/link";
import {upsctestuser}  from "../../components/Service/prefit";
import dynamic from 'next/dynamic';
import { useState } from "react";
const Otpverification = dynamic(()=>import("../../components/Modal/Otpverification"));


const Prelims_Form = () => {
  const[verified,setverified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalOtpstatus, setmodalOtpstatus] = useState(null);
  const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
  const [valuephno, setvaluephno] = useState(undefined);
  const [captchaerror, setcaptchaerror] = useState(undefined);
  function convertJsonStringToNumber(jsonString) {
    // Parse the JSON string to an object
    const jsonObject = JSON.parse(jsonString);
    // Iterate over the keys and convert numeric strings to numbers
    for (const key in jsonObject) {
      if (jsonObject.hasOwnProperty(key)
&& !isNaN(jsonObject[key])) {
        jsonObject[key] = Number(jsonObject[key]);
      }
    }

    
return jsonObject;
}

  function onChange(value) {
    if(value==null){
      setverified(false);
    }
    else{   
      setverified(true);
    }
  }
  async function handleOnSubmit(e) {
    e.preventDefault();


  if(verified){
      const formData = {};
      formData['formType']="upscprefittest2024";
      formData['title']="upsc prefit test 2024";
     
      Array.from(e.currentTarget.elements).forEach((field) => { 
        if (!field.name) return; 
        formData[field.name] = field.value;
      });
      //formData['countryCode'] = "+91"; 
      formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
        formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
        const transform={fields:{...formData}};
        console.log(transform);
  
         setIsLoading(true);
         upsctestuser(transform)
             .then(response => {
                
                 setModalOtp(true);
                 setmodalOtpstatus(response.message);
                 window.grecaptcha.reset(setverified);
                 setverified(false);
                 setvaluephno(undefined);
                 document.getElementById("prefitform").reset();
                 setIsLoading(false);
             })
             .catch(error => {
              setModalOtp(true);
              setmodalOtpstatus("failure");
              window.grecaptcha.reset(setverified);
              setverified(false);
              setIsLoading(false);
            })   
      }
      else{     
        setcaptchaerror(true);
          setTimeout(() => { 
          setcaptchaerror(false);
        }, 3000);
      }
    }
      return(
      <>
      
      {isLoading && 
     <div class="APIPreLoader" id="APIPreLoader">
      <div class="loader">Loading...</div>
     </div>
      }

<Otpverification show={modalOtp} title={modalOtpstatus} frompage="upscprefittest2024" onHide={() => setModalOtp(false)} />
    <div className="container-fluid pt-3">
        <div className="row mx-auto pt-3" style={{background: "#FFF2F2 0% 0% no-repeat padding-box" , opacity: "1"}}>

            <div className="container pt-4 ">

                <div className="row">

                <div className="col-md-8 col-12 mx-auto">
                <p className={`${styles.contactheader} mb-md-0`}>Registration Form</p>
                <p className={`${styles.acheiverrank} `} style={{color:"#DB1B0D"}}>Kindly post your queries in the below form. We will get in touch with you shortly.</p>
                <form  onSubmit={handleOnSubmit} id="prefitform" autoComplete="off">

         <div className="row pt-4">

                <div className="col-12 col-xl-3 col-lg-4 col-md-6">
            <div className="mb-4">
              <input type="text"   className={`${styles.acheiverrank} form-control`} autoComplete="off" placeholder="Name" pattern="[A-Za-z]{3,}" name="name" minLength="1" required/>
            </div>
          </div>

          <div className="col-12 col-xl-3 col-lg-4 col-md-6">
            <div className="mb-4">
              <input type="email"   className={`${styles.acheiverrank} form-control`} title="Please enter a valid email address" placeholder="Email Address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required/>
            </div>
          </div>

          <div className="col-12 col-xl-3 col-lg-4 col-md-6">
            <div className="mb-4">
            <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
            </div>
          </div>

          <div className="col-12 col-xl-3 col-lg-4 col-md-6">
            <div className="mb-4">
                <select className={`${styles.acheiverrank} form-select form-control`} id="autoSizingSelect prelimform"  name="branch" autoComplete="off" placeholder="Years of Experience"  required>
                    <option value="" disabled selected hidden>Select Center</option>
                    <option value="Chennai">Chennai</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Bengaluru">Bengaluru</option>
                    <option value="Thiruvananthapuram">Thiruvananthapuram</option>
                    <option value="Hyderabad">Hyderabad</option>
                    <option value="Trichy">Trichy</option>
                    <option value="Salem">Salem</option>
                    <option value="Coimbatore">Coimbatore</option>
                    <option value="Madurai">Madurai</option>
                </select>
            </div>
          </div>

          <div className="col-12 col-xl-3 col-lg-4 col-md-6">
            <div className="mb-4">
                <select className={`${styles.acheiverrank} form-select form-control`} id="autoSizingSelect prelimform"  name="modeOfExam" autoComplete="off" placeholder="Years of Experience"  required>
                    <option value="" disabled selected hidden>Mode of Exam</option>
                    <option value="Offline">Offline</option>
                    <option value="Online">Online</option>
                </select>
            </div>
          </div>

          <div className="col-12">
            <div className="form-check">
                <input className="form-check-input ps-3" type="checkbox" value="" id={styles.invalidCheck2} />
                <label className={`${styles.checkboxcontent} form-check-label`}  htmlFor="invalidCheck2">
                    I would like to receive updates from Shankar IAS Academy
                </label>
            </div>
          </div>
    
          <div className="d-flex flex-wrap mb-3">
          <div className="me-3 mt-2">
          <ReCAPTCHA className={`${styles.captcha}`}
          sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"     
          onChange={onChange}
          />
                    <div className="">
                      {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                    </div>
          </div>

          <div className="my-auto">
     
          <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
          </div>

          <div className="my-auto mx-auto ">  
             <p className={`${styles.aboutparagraph2} p-1`}><Link href="/pdf/Shankar IAS -UPSC Prelims 2024 Questions Reflections_compressed.pdf" rel="noreferrer" target="_blank" className={`${styles.program}`}><span className={`${styles.dot} pe-2`}>*</span>UPSC Prelims 2024 Reflections <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"32px",color:"#DB1B0D"}}></i></Link></p>
          </div>
          
          </div>
          
        </div>

      
                </form>
              
                </div>

                </div>

            </div>
            
        </div>
    </div>
    </>
    )
}
export default Prelims_Form;